module.exports = __webpack_public_path__ + "static/media/pragmaticmotobajaj.e921aac6.webp";